"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    // shipment 1
    {
        id: 1,
        metaId: null,
        recipientId: 1,
        senderId: 1,
        shipmentId: 45,
        stateId: 1,
        timeSlotId: 1,
        timestamp: '2019-01-14 09:00:00+00',
        userSub: 'demo-user',
        version: 1,
    },
    {
        id: 3,
        metaId: null,
        recipientId: 1,
        senderId: 1,
        shipmentId: 45,
        stateId: 2,
        timeSlotId: 1,
        timestamp: '2019-01-14 09:00:30+00',
        userSub: 'demo-user',
        version: 2,
    },
    {
        id: 4,
        metaId: null,
        recipientId: 1,
        senderId: 1,
        shipmentId: 45,
        stateId: 4,
        timeSlotId: 1,
        timestamp: '2019-01-14 13:00:30+00',
        userSub: 'demo-user',
        version: 2,
    },
    {
        id: 2,
        metaId: null,
        recipientId: 1,
        senderId: 1,
        shipmentId: 45,
        stateId: 4,
        timeSlotId: 1,
        timestamp: '2019-01-14 13:00:30+00',
        userSub: 'demo-user',
        version: 0,
    },
    // shipment 2
    {
        id: 5,
        metaId: null,
        recipientId: 2,
        senderId: 1,
        shipmentId: 46,
        stateId: 1,
        timeSlotId: 1,
        timestamp: '2019-01-14 09:00:00+00',
        userSub: 'demo-user',
        version: 1,
    },
    {
        id: 7,
        metaId: null,
        recipientId: 2,
        senderId: 1,
        shipmentId: 46,
        stateId: 2,
        timeSlotId: 1,
        timestamp: '2019-01-14 09:00:30+00',
        userSub: 'demo-user',
        version: 2,
    },
    {
        id: 8,
        metaId: null,
        recipientId: 2,
        senderId: 1,
        shipmentId: 46,
        stateId: 4,
        timeSlotId: 1,
        timestamp: '2019-01-14 13:00:30+00',
        userSub: 'demo-user',
        version: 2,
    },
    {
        id: 6,
        metaId: null,
        recipientId: 2,
        senderId: 1,
        shipmentId: 46,
        stateId: 4,
        timeSlotId: 1,
        timestamp: '2019-01-14 13:00:30+00',
        userSub: 'demo-user',
        version: 0,
    },
    // shipment 3
    {
        id: 9,
        metaId: null,
        recipientId: 3,
        senderId: 1,
        shipmentId: 47,
        stateId: 1,
        timeSlotId: 1,
        timestamp: '2019-01-14 09:00:00+00',
        userSub: 'demo-user',
        version: 1,
    },
    {
        id: 11,
        metaId: null,
        recipientId: 3,
        senderId: 1,
        shipmentId: 47,
        stateId: 2,
        timeSlotId: 1,
        timestamp: '2019-01-14 09:00:30+00',
        userSub: 'demo-user',
        version: 2,
    },
    {
        id: 12,
        metaId: null,
        recipientId: 3,
        senderId: 1,
        shipmentId: 47,
        stateId: 4,
        timeSlotId: 1,
        timestamp: '2019-01-14 13:00:30+00',
        userSub: 'demo-user',
        version: 2,
    },
    {
        id: 10,
        metaId: null,
        recipientId: 3,
        senderId: 1,
        shipmentId: 47,
        stateId: 4,
        timeSlotId: 1,
        timestamp: '2019-01-14 13:00:30+00',
        userSub: 'demo-user',
        version: 0,
    },
    // shipment 4
    {
        id: 13,
        metaId: null,
        recipientId: 4,
        senderId: 1,
        shipmentId: 48,
        stateId: 1,
        timeSlotId: 1,
        timestamp: '2019-01-14 09:00:00+00',
        userSub: 'demo-user',
        version: 1,
    },
    {
        id: 15,
        metaId: null,
        recipientId: 4,
        senderId: 1,
        shipmentId: 48,
        stateId: 2,
        timeSlotId: 1,
        timestamp: '2019-01-14 09:00:30+00',
        userSub: 'demo-user',
        version: 2,
    },
    {
        id: 16,
        metaId: null,
        recipientId: 4,
        senderId: 1,
        shipmentId: 48,
        stateId: 4,
        timeSlotId: 1,
        timestamp: '2019-01-14 13:00:30+00',
        userSub: 'demo-user',
        version: 2,
    },
    {
        id: 14,
        metaId: null,
        recipientId: 4,
        senderId: 1,
        shipmentId: 48,
        stateId: 4,
        timeSlotId: 1,
        timestamp: '2019-01-14 13:00:30+00',
        userSub: 'demo-user',
        version: 0,
    },
    // shipment 5
    {
        id: 17,
        metaId: null,
        recipientId: 5,
        senderId: 1,
        shipmentId: 49,
        stateId: 1,
        timeSlotId: 1,
        timestamp: '2019-01-14 09:00:00+00',
        userSub: 'demo-user',
        version: 1,
    },
    {
        id: 19,
        metaId: null,
        recipientId: 5,
        senderId: 1,
        shipmentId: 49,
        stateId: 2,
        timeSlotId: 1,
        timestamp: '2019-01-14 09:00:30+00',
        userSub: 'demo-user',
        version: 2,
    },
    {
        id: 20,
        metaId: null,
        recipientId: 5,
        senderId: 1,
        shipmentId: 49,
        stateId: 4,
        timeSlotId: 1,
        timestamp: '2019-01-14 13:00:30+00',
        userSub: 'demo-user',
        version: 2,
    },
    {
        id: 18,
        metaId: null,
        recipientId: 5,
        senderId: 1,
        shipmentId: 49,
        stateId: 4,
        timeSlotId: 1,
        timestamp: '2019-01-14 13:00:30+00',
        userSub: 'demo-user',
        version: 0,
    },
];
